import { notification } from 'antd';
import React, { useEffect } from 'react';
import useUserStore from '../../stores/store';
import { getNotificationElapsedTime } from '../../services/notification-service';

/**
 * It display notification message.
 * Step 1: Store notification with store time
 * Step 2: Listen notification store change
 * Step 3: Get elapsed time
 * Step 4: if elapsed time less than 1 sec show notification otherwise it is assumed that before notification dialog close application closed unexpectedly.
 * 
 */
const NotificationComponent = () => {
  const [api, contextHolder] = notification.useNotification();
  const {notifications, clearNotification} = useUserStore();  
  
  const onClose = () => {
    clearNotification();
  }

  const showMessage = (text, isError, title = 'Error') => {
    const type = isError ? 'error' : 'success';
    const message = isError ? title : title === 'Error' ? 'Success' : title;

    api[type]({
      message: message,
      description: text,
      duration: 3, // 3 sec
      pauseOnHover: true,
      showProgress: true,
      onClose
    });
  };
  
    const showNotice = (text, isError = true) => {
      showMessage(text, isError);
    }

    useEffect(() => {
      if (notifications.length === 0) {
        return;
      }

      const msgObj = notifications[notifications.length - 1];
      const elapsedTime = getNotificationElapsedTime(msgObj.storedAt);
      
      if (elapsedTime <= 1) {
        showNotice(msgObj.text, msgObj.isError)
      }

    }, [notifications])
  
    return <>
    {contextHolder}
    </>;
  };

  export default NotificationComponent;